import React, { useEffect } from 'react';
import { Select } from 'antd';
import { shutdownInitiatorsQuery } from '../../../../../../shared/api/queries';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { useNewCityValueSubscription } from '../../../lib/subscriptions';

const { useShutdownInitiators } = shutdownInitiatorsQuery;
const { Option } = Select;
const fieldName = fieldNames.initiators;
const cityFieldName = fieldNames.city;

const InitiatorsField = ({ form, initialValue, editMode, initCityId }) => {
  const cityDependentData = useNewCityValueSubscription();
  const cityId = editMode ? initCityId : cityDependentData?.[cityFieldName];

  const { data, isFetching } = useShutdownInitiators(cityId, {
    staleTime: Infinity,
    enabled: editMode ? true : Boolean(cityId),
  });

  useEffect(() => {
    if (cityDependentData && !isFetching && data?.length) {
      const value = cityDependentData.hasOwnProperty(fieldName)
        ? cityDependentData[fieldName]
        : form.getFieldValue(fieldName);

      const updatedVal =
        value?.filter((id) => data.some((dataItem) => dataItem.id === id)) ||
        [];

      form.setFieldsValue({ [fieldName]: updatedVal });
    }
  }, [cityDependentData, isFetching, data]);

  return (
    <Field
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label="Инициаторы"
      decoratorOptions={{
        initialValue: data?.length && !editMode ? initialValue : [],
        rules: [
          { required: true, message: 'Укажите инициаторов', type: 'array' },
        ],
      }}
      fieldProps={{
        placeholder: 'Выберите инициаторов',
        loading: isFetching,
        mode: 'multiple',
        optionFilterProp: 'searchtext',
        disabled: !editMode && !cityId,
      }}
      items={
        editMode && initialValue?.length
          ? data?.filter((item) => !initialValue.includes(item.id)) || []
          : data
      }
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
          searchtext={item.name}
        >
          {item.name}
        </Option>
      )}
    />
  );
};

export default InitiatorsField;
